const OPTIONS = [
  {
    id: "inter",
    name: "Option 1 · Inter",
    heading: "'Inter', sans-serif",
    headingWeight: 600,
    body: "'Inter', sans-serif",
    mono: "'Inter', sans-serif",
    note: "The modern SaaS standard — neutral, ultra-legible, unmistakably B2B. Safe and universally trusted.",
  },
  {
    id: "plex",
    name: "Option 2 · IBM Plex Sans + Plex Mono",
    heading: "'IBM Plex Sans', sans-serif",
    headingWeight: 600,
    body: "'IBM Plex Sans', sans-serif",
    mono: "'IBM Plex Mono', monospace",
    note: "Designed for IBM — technical, trustworthy, with genuine enterprise heritage and subtle character.",
  },
  {
    id: "grotesk",
    name: "Option 3 · Space Grotesk + Inter",
    heading: "'Space Grotesk', sans-serif",
    headingWeight: 600,
    body: "'Inter', sans-serif",
    mono: "'Space Grotesk', sans-serif",
    note: "Confident, modern, lightly technical headlines paired with a clean neutral body. Feels forward-looking.",
  },
  {
    id: "manrope",
    name: "Option 4 · Manrope",
    heading: "'Manrope', sans-serif",
    headingWeight: 700,
    body: "'Manrope', sans-serif",
    mono: "'Manrope', sans-serif",
    note: "Refined geometric sans — premium, contemporary and friendly. Popular with high-end SaaS brands.",
  },
  {
    id: "archivo",
    name: "Option 5 · Archivo + Inter",
    heading: "'Archivo', sans-serif",
    headingWeight: 700,
    body: "'Inter', sans-serif",
    mono: "'Libre Franklin', sans-serif",
    note: "Strong, editorial-yet-corporate headlines with a neutral workhorse body. Bold and authoritative.",
  },
];

const Sample = ({ o }) => (
  <div className="rounded-2xl bg-white border border-[#3E2818]/10 p-7 lg:p-9" data-testid={`font-sample-${o.id}`}>
    <div className="flex items-center justify-between gap-3 mb-5">
      <span className="text-[11px] uppercase tracking-[0.22em] text-[#8A5730] font-semibold" style={{ fontFamily: o.mono }}>
        {o.name}
      </span>
    </div>

    <h2
      className="tracking-tight text-[#3E2818] leading-[1.1] text-3xl lg:text-[2.6rem]"
      style={{ fontFamily: o.heading, fontWeight: o.headingWeight }}
    >
      What It Takes to Achieve <span style={{ color: "#EDA13A" }}>Agentic Alpha</span>
    </h2>

    <p className="mt-4 text-base text-[#3E2818]/65 leading-relaxed max-w-2xl" style={{ fontFamily: o.body }}>
      Give every agent the context to understand your business, then orchestrate agents, people and systems across
      end-to-end enterprise workflows — governed, reliable and production-ready.
    </p>

    <div className="mt-7 pt-6 border-t border-[#3E2818]/10 flex flex-wrap items-end gap-x-10 gap-y-4">
      <div>
        <span className="tracking-tight text-[#8A5730] text-4xl lg:text-5xl" style={{ fontFamily: o.heading, fontWeight: o.headingWeight }}>
          &lt;60 days
        </span>
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#3E2818]/45 mt-1.5" style={{ fontFamily: o.mono }}>
          Time to Value
        </p>
      </div>
      <div>
        <span className="tracking-tight text-[#8A5730] text-4xl lg:text-5xl" style={{ fontFamily: o.heading, fontWeight: o.headingWeight }}>
          &gt;95%
        </span>
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#3E2818]/45 mt-1.5" style={{ fontFamily: o.mono }}>
          Decision Precision
        </p>
      </div>
      <p className="text-sm text-[#3E2818]/55 leading-relaxed flex-1 min-w-[220px]" style={{ fontFamily: o.body }}>
        AI Forward Deployed Engineer — from business requirement to production-ready agentic application at AI speed.
      </p>
    </div>

    <p className="text-[12px] text-[#3E2818]/50 mt-6 leading-relaxed" style={{ fontFamily: o.body }}>
      {o.note}
    </p>
  </div>
);

export default function FontOptions() {
  return (
    <div className="min-h-screen bg-[#F7F5F0]">
      <div className="max-w-5xl mx-auto px-6 py-12">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#8A5730] font-semibold" style={{ fontFamily: "'Inter', sans-serif" }}>
          Typography Options · Enterprise / B2B
        </p>
        <h1 className="text-2xl lg:text-3xl font-bold mt-2 tracking-tight text-[#3E2818]" style={{ fontFamily: "'Inter', sans-serif" }}>
          Choose a font direction
        </h1>
        <p className="text-sm mt-3 max-w-2xl leading-relaxed text-[#3E2818]/60" style={{ fontFamily: "'Inter', sans-serif" }}>
          The current site uses <strong>Fraunces</strong> (an editorial serif) for headings — that&rsquo;s the &ldquo;Claude&rdquo; feel.
          Below are professional, enterprise-grade sans-serif directions rendered with real site text. Tell me the option number and I&rsquo;ll roll it out site-wide.
        </p>

        <div className="mt-8 space-y-5">
          {OPTIONS.map((o) => (
            <Sample key={o.id} o={o} />
          ))}
        </div>
      </div>
    </div>
  );
}
